import { setRemoteDefinitions } from '@nx/angular/mf';
import { environment } from './environments/environment';

const manifestPath = `/assets/module-federation.manifest.${environment.name}.json`;

fetch(manifestPath)
  .then((res) => res.json())
  .then((definitions) => setRemoteDefinitions(definitions))
  .then(() => import('./bootstrap').catch((err) => console.error(err)));
